import React from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { Page } from '../../hoc/Page.jsx';
import LoginForm from './LoginForm.jsx';
import { userLogin } from '../../actions/user';


class Login extends React.Component {
  render() {
    return <div>
    { this.props.isAuth ? <Redirect to={'/' + this.props.lang + '/my/'}/>
                        : <LoginForm onSubmit={ this.props.userLogin }/> }
    </div>
  }
}

let mapStateToProps = (state) => {
  return {
    isAuth: state.auth.isAuth,
    lang: state.auth.lang,
  }
};

export default connect(mapStateToProps, { userLogin })(Login, Page);